import styled from 'styled-components';


export const MenuRight = styled.ul`
  @media (max-width: 990px){
    display: none;
  }

  li {
    display: inline-block;
    border-right: 1px solid #fff;

     &:nth-child(1){
      border-right: 1px solid #fff;
    }
      &:nth-child(3){
        border-right: 1px solid #fff;
      }
  }
  span {
    padding-left: 5px;
  }

  a {
    display: flex;
    align-items: center;
    padding: 26px 8px;
    color: #fff;
    background-color: #554f4d;
    transition: all .3s linear;

    &:hover {
      color: #fff;
      background-color: #da9c15;
    }
  }
`;

export const MenuRightAdmin = MenuRight.extend`
  display: flex;
`;


export const MenuLeft = styled.ul`
  display: flex;

  li:not(:first-child) a {
    @media (max-width: 990px){
      display: none;
    }
  }
  li:nth-child(2) i{
    position: absolute;
    top: 50%;
    left: 100px;
    transform: translateY(-50%);

    @media screen and (min-width: 768px) {
      position: relative;
      margin-left: 15px;
      top: auto;
      left: auto;
      transform: none;
    }
  }

  a {
    display: block;
    padding: 26px 19px;
    transition: all .3s linear;

    &:hover {
      color: #fff;
      background-color: #da9c15;
    }
  }

  img {
    max-width: 30px;
  }
`

export const Logo = styled.li`
  a {
    padding: 10px 15px 0;

    &:hover {
      background-color: transparent;
    }
    @media (max-width: 992px) {
      display: block;
      margin-left: 10px;
    }
    @media (min-width: 768px) {
      width: 100%;
    }
  }
  img {
    margin-bottom: 5px;
  }
`;

export const MobileSidebar = styled.div`
  position: absolute;
  top: auto;
  width: ${props => props.open ? "230px" : "0"};
  left: ${props => props.open ? "0" : "-230px"};
  transition: all .15s linear;
  height: 100vh;
  padding-bottom: 100%;
  background-color: #edbd2f;

  @media (min-width: 991px) {
    display: none;
  }

  a {
    font-size: 13px;
    display: block;
		padding: 12px 5px 12px 15px;
    border-bottom: 1px solid #fff;
  }
  i {
		padding-right: 5px;
		font-size: 13px;
		min-width: 20px;
    color: #fff;
	}
  img {
    width: 20px;
    height: auto;
  }
`;
export const Toggle = styled.li`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 10px;
	cursor: pointer;
  color: #fff;
	font-size: 18px;

  @media (min-width: 992px){
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/system/header/components.js